// Centralised content for Artful Contemporary

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/lxr371o2_Artful_Logo_V06.png";

export const LOGO_URL_LIGHT =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/eyitzu1d_Artful_logo.png";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Our Exhibitions", to: "/exhibitions" },
  { label: "Our Venues", to: "/venues" },
  { label: "Our Services", to: "/services" },
  { label: "Our Concepts", to: "/projects" },
  { label: "Shop", to: "https://artful-merchandise.com", external: true },
];

export const HERO_SLIDES = [
  {
    image:
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_contemporary-gallery/artifacts/c72jrdwb_artful%20slider%203.jpg",
    imageMobile:
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_contemporary-gallery/artifacts/9wqeucwy_artful%20mobil%20slider%203.jpg",
    eyebrow: "Starting October 22",
    title: "Banksy Street Is The Museum",
    cta: "Explore Exhibition",
    link: "https://banksymuseo.it/en/home-2/",
    countdownTo: "2026-10-22T00:00:00",
  },
  {
    image:
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_contemporary-gallery/artifacts/2vemhg19_house%20of%20banksy.jpg",
    imageMobile:
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_contemporary-gallery/artifacts/3q7tb51i_house%20of%20banksy%20mobil.jpg",
    eyebrow: "Starting September 11",
    title: "House of Banksy Stuttgart",
    cta: "Explore Exhibition",
    link: "https://house-of-banksy.com/en/stuttgart/",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/z1qiudnl_slider1.jpg",
    eyebrow: "Artful Contemporary",
    title: "Where Art Becomes Experience",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/p98j9tm6_slider2.JPG",
    eyebrow: "Now on view",
    title: "The World of Banksy",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/llg4z52r_slider3.JPG",
    eyebrow: "11 venues worldwide",
    title: "An International Stage for Contemporary Art",
  },
];

export const EXHIBITION_IMAGES = [
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/mnq167ic_Barcelona%201.png",
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/vh7pro58_Prague%206.jpeg",
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/tc6eo1dp_Madrid%202.png",
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/2zv69wl2_dortmund%206.JPG",
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/ax68gew5_Krakow%201.jpg",
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/mnq167ic_Barcelona%201.png",
];

const IMG_BARCELONA =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/mnq167ic_Barcelona%201.png";
const IMG_PRAGUE =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/vh7pro58_Prague%206.jpeg";
const IMG_MADRID =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/tc6eo1dp_Madrid%202.png";
const IMG_DORTMUND =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/2zv69wl2_dortmund%206.JPG";
const IMG_KRAKOW =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/ax68gew5_Krakow%201.jpg";
const IMG_PARIS =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/eujv5jah_Paris%201.jpg";
const IMG_AMSTERDAM =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/f9vea0f5_Amsterdam%202.jpg";
const IMG_BRUSSELS =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/78rk5dlc_Brussel%203.jpg";
const IMG_LISBON =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/6252m4vi_Lisbon%203.jpg";
const IMG_NEWYORK =
  "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/8pwqs5m2_newyork.webp";
const IMG_TURIN =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_contemporary-gallery/artifacts/o8233zt5_homepage%201.jpg";
const IMG_STUTTGART =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_contemporary-gallery/artifacts/7v0h3oer_magnific_exact-composition-of-refe_0eDh0hATfW.png";

export const CURRENT_EXHIBITIONS = [
  { schedule: "Permanently", title: "BANKSY MUSEUM", city: "Amsterdam, Netherlands", hours: "Mon–Thu & Sun: 10:00 – 19:00 · Fri & Sat: 10:00 – 20:00", image: IMG_AMSTERDAM, link: "https://museumbanksy.nl/en/" },
  { schedule: "Permanently", title: "BANKSY MUSEUM", city: "Barcelona, Spain", hours: "Open Daily: 10:00 – 20:00", image: IMG_BARCELONA, link: "https://museobanksy.es/en/" },
  { schedule: "Permanently", title: "BANKSY MUSEUM", city: "Brussels, Belgium", hours: "Open Daily: 10:00 – 19:00", image: IMG_BRUSSELS, link: "https://banksymuseum.be/en/" },
  { schedule: "Permanently", title: "BANKSY MUSEUM", city: "Krakow, Poland", hours: "Open Daily: 11:00 – 19:00", image: IMG_KRAKOW, link: "https://muzeumbanksy.pl/" },
  { schedule: "Permanently", title: "BANKSY MUSEUM", city: "Lisbon, Portugal", hours: "Mon–Fri: 11:00 – 20:00 · Sat–Sun: 10:00 – 20:00", image: IMG_LISBON, link: "https://www.museubanksy.pt/" },
  { schedule: "Permanently", title: "BANKSY MUSEUM", city: "Madrid, Spain", hours: "Open Daily: 10:00 – 20:00", image: IMG_MADRID, link: "https://museobanksy.es/en/" },
  { schedule: "Permanently", title: "BANKSY MUSEUM", city: "New York, USA", hours: "Open Daily: 10:00 – 20:00", image: IMG_NEWYORK, link: "https://museumbanksy.com/" },
  { schedule: "Permanently", title: "BANKSY MUSEUM", city: "Paris, France", hours: "Mon–Fri: 12:00 – 21:00 · Sat: 10:00 – 21:00 · Sun: 10:00 – 19:00", image: IMG_PARIS, link: "https://museebanksy.fr/" },
  { schedule: "Permanently", title: "BANKSY MUSEUM", city: "Prague, Czech Republic", hours: "Mon–Wed: 10:00 – 20:00 · Thu–Sun: 10:00 – 21:00", image: IMG_PRAGUE, link: "https://theworldofbanksy.cz/" },
  { title: "HOUSE OF BANKSY", city: "Stuttgart, Deutschland", hours: "Tue–Sun: 11:00 – 19:00", image: IMG_STUTTGART, link: "https://house-of-banksy.com/en/stuttgart/", touring: true },
  { schedule: "Starting October 22", title: "BANKSY STREET IS THE MUSEUM", city: "Turin, Italy", hours: "Tue–Sun: 10:00 – 19:00", image: IMG_TURIN, link: "https://banksymuseo.it/en/", touring: true },
];

export const PAST_EXHIBITIONS = [
  { year: "2026", title: "House of Banksy", city: "Dortmund" },
  { year: "2026", title: "Banksy The Pop-Up Experience", city: "Reggio nell'Emilia" },
  { year: "2025", title: "The World of Banksy", city: "Amsterdam" },
  { year: "2025", title: "The World of Banksy", city: "Düsseldorf" },
  { year: "2025", title: "The World of Banksy", city: "Madrid" },
  { year: "2025", title: "The World of Banksy", city: "Milano Certosa" },
  { year: "2024", title: "The World of Banksy", city: "Napoli" },
  { year: "2024", title: "The World of Banksy", city: "Budapest" },
  { year: "2024", title: "The World of Banksy", city: "New York" },
  { year: "2024", title: "The World of Banksy", city: "Krakau" },
  { year: "2023", title: "Body Worlds", city: "Torino" },
  { year: "2023", title: "Mystery of Banksy", city: "Stuttgart", note: "Only Merchandise Collaboration" },
  { year: "2023", title: "The World of Banksy", city: "Bologna" },
  { year: "2023", title: "The World of Banksy", city: "Genoa" },
  { year: "2023", title: "Body Worlds", city: "Milano" },
  { year: "2022", title: "The World of Banksy", city: "Trieste", note: "Only Merchandise Collaboration" },
  { year: "2022", title: "The World of Banksy", city: "Roma" },
  { year: "2022", title: "The World of Banksy", city: "Lisbon" },
  { year: "2022", title: "The World of Banksy", city: "Verona" },
  { year: "2022", title: "The World of Banksy", city: "Brussels" },
  { year: "2022", title: "The World of Banksy", city: "Beirut" },
  { year: "2022", title: "The World of Banksy", city: "Torino" },
  { year: "2021", title: "The World of Banksy", city: "Dubai" },
  { year: "2021", title: "The World of Banksy", city: "Milano Central Station" },
  { year: "2020", title: "The World of Banksy", city: "Prague Church" },
  { year: "2020", title: "The World of Banksy", city: "Milano Teatro Nuovo" },
  { year: "2020", title: "The World of Banksy", city: "Prague Mannes" },
  { year: "2020", title: "The World of Banksy", city: "Barcelona" },
  { year: "2019", title: "The World of Banksy", city: "Paris" },
  { year: "2018", title: "The World of Banksy", city: "Berlin Bikini" },
];

export const HISTORY = [
  {
    year: "2018",
    title: "Foundation & Vision",
    body:
      "Artful Events was founded as a company focused on cultural events and exhibition production. From the start, the vision was to create and operate large-scale, internationally relevant contemporary art exhibitions. In the same year, the first permanent Banksy Museum opened in Paris, launching the innovative and experience-driven exhibition concept.",
  },
  {
    year: "2019",
    title: "Strategic Positioning & Preparation",
    body:
      "After the Paris launch, operational expertise was strengthened. Strategic preparations began for expansion in both permanent museum and touring exhibition formats.",
  },
  {
    year: "2020",
    title: "Establishment of the Permanent Museum Model",
    body:
      "Two new permanent Banksy Museums opened in Barcelona, Spain, and Prague, Czech Republic. These openings confirmed strong long-term audience demand for permanent museum formats.",
  },
  {
    year: "2021–22",
    title: "Touring Expansion & International Reach",
    body:
      "Touring exhibitions were launched in Milan, Italy (Teatro Nova in 2021 and Centrale in 2022). In 2022, the first Middle East touring exhibition opened in Dubai, UAE.",
  },
  {
    year: "2023",
    title: "European Network Growth & Diversification",
    body:
      "New stops were added in Verona and Bologna, Italy, Beirut, Lebanon, and Krakow, Poland (permanent Banksy Museum — December 2023). A strategic partnership with Body Worlds began, marking an important step in portfolio diversification.",
  },
  {
    year: "2024",
    title: "Consolidation of Permanent Museums & Touring Scale",
    body:
      "Touring exhibitions opened in Naples, Italy, and Budapest, Hungary. New permanent Banksy Museums were launched in Madrid, Spain, Brussels, Belgium, and New York, USA — one of our most significant steps toward a truly global vision.",
  },
  {
    year: "2025",
    title: "Network Expansion & Major Touring Projects",
    body:
      "A new permanent Banksy Museum opened in Amsterdam, Netherlands. Large-scale touring exhibitions launched in Milan Certosa, Düsseldorf (May 2025 – March 2026), and Dortmund (December 2025), Germany.",
  },
  {
    year: "2026+",
    title: "Strategic Development & New Horizons",
    body:
      "A brand-new permanent exhibition venue opens in Milan Certosa, serving as a strategic platform for future collaborations and large-scale productions. Future Banksy projects will focus increasingly on permanent exhibitions, while new independent concepts expand the touring portfolio.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "It's an excellent museum of Banksy's art collection. They've recreated many of Banksy's famous pieces and I really like the details and the description they have explaining where the art piece is found and the story behind it. It's just a fascinating experience — highly recommended if you are a fan of arts and modern art with meaning behind it.",
    name: "EN.",
    place: "The World of Banksy Prague",
  },
  {
    quote:
      "Beautiful exhibition, well organized and with comprehensive explanations of the works: an opportunity to get to know this artist better.",
    name: "M.M.",
    place: "The World of Banksy Napoli",
  },
  {
    quote:
      "Fantastic exhibit. You will see original and copied artworks of Banksy and a video explaining the mystery behind his or their identity. Enjoy, also the shop. The custodian and the shop assistant were very friendly.",
    name: "D.M.",
    place: "The World of Banksy Roma",
  },
  {
    quote:
      "The World of Banksy Expo enabled us to see the most iconic collection of Banksy. It's a perfect stop for those wanting to learn something more about his work with a powerful message expressed through street art.",
    name: "D.J.",
    place: "Banksy Museum Paris",
  },
];

export const SHOP_ITEMS = [
  {
    title: "Banksy Exhibition Book",
    image: "https://artful-merchandise.com/cdn/shop/files/DSC01830-1-scaled.jpg?v=1759860896&width=1024",
    link: "https://artful-merchandise.com/en/collections/buecher/products/banksy-books-2",
  },
  {
    title: "Canvas · Flower Thrower",
    image: "https://artful-merchandise.com/cdn/shop/files/DSC06124-scaled.jpg?v=1759860933&width=1024",
    link: "https://artful-merchandise.com/en/collections/canvas-leinwaende/products/leinwand-flower-thrower",
  },
  {
    title: "Stone Coaster · Girl With Balloon",
    image: "https://artful-merchandise.com/cdn/shop/files/DSC04741-scaled.jpg?v=1759860999&width=1024",
    link: "https://artful-merchandise.com/en/collections/coasters/products/banksy-coasters-17",
  },
  {
    title: "Large Jute Bag · Rude Copper",
    image: "https://artful-merchandise.com/cdn/shop/files/DSC03702-1-scaled.jpg?v=1759860909&width=1024",
    link: "https://artful-merchandise.com/en/collections/canvas-jutebeutel/products/jutebeutel-gross-rude-copper",
  },
];

export const TEAM = [
  {
    name: "Egehan Türkan",
    role: "CEO",
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODA5MjA5Mjh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Derya Evren",
    role: "Head of Operations",
    image:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODA5MjA5Mjh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Deniz Türkan",
    role: "Head of Merchandise",
    image:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODA5MjA5Mjh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Emre Ezelli",
    role: "Creative Director",
    image:
      "https://images.unsplash.com/photo-1521119989659-a83eee488004?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODA5MjA5Mjh8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const SERVICES = [
  {
    n: "01",
    title: "Art Exhibition Management",
    body: "We offer unique art experiences in prestigious galleries and extraordinary venues.",
  },
  {
    n: "02",
    title: "Art Event Management",
    body: "We design creative events that enhance the interaction between brands and art.",
  },
  {
    n: "03",
    title: "Original Art Concepts",
    body: "We develop innovative projects that inspire the art world.",
  },
  {
    n: "04",
    title: "Consulting",
    body: "We provide customized strategies in art and event management.",
  },
  {
    n: "05",
    title: "Artist Management",
    body:
      "We offer professional support to guide artists' careers, facilitate their participation in international projects, and showcase their works worldwide.",
  },
  {
    n: "06",
    title: "Project & Partnership",
    body:
      "Artful builds meaningful partnerships with leading institutions, brands, and artists to create innovative projects that shape the contemporary art landscape.",
  },
];

export const PARTNERSHIPS = [
  {
    title: "The World of Banksy",
    subtitle: "Our Original Concept",
    body:
      "Through The World of Banksy, we aim to bring the artist's message to a wider audience by offering art lovers the opportunity to discover Banksy's works from many different places around the world, all in one location. In addition to original works, we collaborate with local graffiti artists to recreate Banksy's artistic vision. This concept explores powerful themes such as war, peace, capitalism, consumerism, and individualism — stimulating visitors' thoughts and emotions.",
    image:
      "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/qx7r2ipp_dusseldorf%205.jpg",
  },
  {
    title: "Andy Warhol: Neo-Popism",
    subtitle: "Coming Soon",
    body:
      "The iconic artist of the 20th century, Andy Warhol's Pop Art legacy is reinterpreted through the lens of the social media age and Neo-Pop aesthetics in this powerful exhibition. A bold experience centered on color, repetition, and fame. Coming soon!",
    image:
      "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/11qvhlav_andy.png",
  },
  {
    title: "Cofo",
    subtitle: "Collaboration Partner",
    body:
      "In collaboration with Cofo, we proudly opened the House of Banksy exhibition in Dortmund. This exciting partnership brings a fresh perspective to contemporary art, successfully presenting Banksy's powerful works in a unique and striking setting.",
    image:
      "https://customer-assets.emergentagent.com/job_contemporary-gallery/artifacts/z8ng4tjw_dortmund%207.JPG",
  },
];

export const FAQS = [
  {
    q: "What services does Artful Events offer for B2B clients?",
    a: "We offer end-to-end solutions, including original art concept creation, exhibition design, artwork selection, installation, marketing, and sales strategy. Our services are designed to provide a seamless experience, from the initial concept to the final exhibition, ensuring a memorable experience for both the client and their audience.",
  },
  {
    q: "How can I collaborate with Artful Events on an exhibition?",
    a: "To collaborate with us, we encourage you to reach out through our contact form or directly by email. Once we receive your inquiry, we'll arrange a consultation to understand your vision and goals. Whether you are interested in a solo exhibition, a large-scale event, or a unique collaboration, we ensure that the exhibition concept and execution meet your expectations while enhancing audience engagement.",
  },
  {
    q: "How can I sponsor one of your events or exhibitions?",
    a: "Sponsoring an exhibition or event with Artful Events is a great opportunity to align your brand with transformative and thought-provoking art experiences. We offer various sponsorship packages that can be tailored to meet your marketing and brand objectives. Our sponsorships provide high visibility through extensive promotional activities, media coverage, and exclusive access to curated art events. To discuss sponsorship opportunities, reach out to our team and we'll provide a detailed proposal based on your interests and brand needs.",
  },
  {
    q: "How can you represent me as an artist?",
    a: "If you're an artist looking for representation, we'd love to hear from you. Artful Events works with talented artists to showcase their work in curated exhibitions and provides comprehensive artist management services. Our team works closely with artists to create impactful exhibitions, handle logistical details, and manage promotional efforts to elevate their presence in the art world. To discuss representation, we recommend submitting your portfolio or reaching out directly to our artist relations team for an initial consultation.",
  },
];

export const COMPANY = {
  address: "Anton-Kux-Str. 2, 41460, Neuss, Germany",
  phone: "(+49) 2131 3134985",
  email: "info@artful-events.de",
  instagram: "https://www.instagram.com/artfulcontemporary/",
  linkedin: "https://www.linkedin.com/company/artful-events/",
  facebook: "https://www.facebook.com/profile.php?id=61586680346109",
};
